import type { ReceiptTemplate } from '../schema';

export const theNorthFaceTemplate: ReceiptTemplate = {
  id: 'the-north-face',
  name: 'The North Face Receipt',
  brand: 'THE NORTH FACE',
  description: 'The North Face outdoor apparel receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'tnf-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/the-north-face.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: [
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tnf-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'store', label: 'Store:', value: '4892' },
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'assoc', label: 'Assoc:', value: 'MIKE W.' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tnf-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'NUPTSE JACKET', quantity: '1', price: '330.00', sku: 'NF847291' },
          { id: '2', name: 'THERMOBALL ECO', quantity: '1', price: '220.00', sku: 'NF847292' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tnf-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '550.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '45.38', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '595.38', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tnf-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tnf-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'LIFETIME WARRANTY\nReturns within 60 days\n\nNEVER STOP EXPLORING',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

